(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baxter-measurement"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.Shopify?.designMode || window.baxterTradeMeasurementInitialized) return;
  window.baxterTradeMeasurementInitialized = true;

  const formId = '9Ytz9q';
  const interactedForms = new WeakSet();
  const sentEvents = new Set();
  const getForm = (target) => target instanceof Element
    ? target.closest(`form[data-cf-form="${formId}"]`)
    : null;

  const sendEvent = (eventName) => {
    if (sentEvents.has(eventName)) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      const parameters = { form_id: formId, form_type: 'trade_account' };
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, parameters);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...parameters });
      } else {
        return;
      }
      sentEvents.add(eventName);
    } catch {}
  };

  const noteInteraction = (event) => {
    const form = getForm(event.target);
    if (event.isTrusted && form) interactedForms.add(form);
  };

  document.addEventListener('input', noteInteraction, true);
  document.addEventListener('change', noteInteraction, true);
  document.addEventListener('cf:field_changed', (event) => {
    const form = getForm(event.target);
    if (form && interactedForms.has(form)) sendEvent('trade_application_started');
  });
  document.addEventListener('cf:form_submitted', (event) => {
    if (event.detail?.formId === formId) sendEvent('trade_application_completed');
  });

  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch {}
  }
})();

  } catch(e) { console.error(e); }
})();
})();
